export default __webpack_public_path__ + "static/media/cachorro-gato@2x.fbed891c.jpg";